module.exports = __webpack_public_path__ + "static/img/tupian.1d41961.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tupian.png
// module id = znS9
// module chunks = 1